/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lustrace_History_WhenInputs */

const cs_lustrace_history_when = /** @type {(inputs: Lustrace_History_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kdy`)
};

const en_lustrace_history_when = /** @type {(inputs: Lustrace_History_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When`)
};

/**
* | output |
* | --- |
* | "When" |
*
* @param {Lustrace_History_WhenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lustrace_history_when = /** @type {((inputs?: Lustrace_History_WhenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lustrace_History_WhenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lustrace_history_when(inputs)
	return cs_lustrace_history_when(inputs)
});